import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, {
    modelValue: _ctx.modelValue,
    type: _ctx.show ? 'text' : 'password',
    class: "pt-2",
    "append-inner-icon": _ctx.show ? 'mdi-eye' : 'mdi-eye-off',
    "onClick:appendInner": _ctx.toggleShow,
    onChange: _ctx.action,
    label: _ctx.label,
    variant: "outlined",
    density: "compact",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (newValue) => _ctx.$emit('update:modelValue', newValue))
  }, null, 8, ["modelValue", "type", "append-inner-icon", "onClick:appendInner", "onChange", "label"]))
}